import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const CurrencyContext = createContext(null);
const LS_KEY = "sp_currency";

export function CurrencyProvider({ children }) {
  const [data, setData] = useState(null);
  const [currency, setCurrencyState] = useState(() => localStorage.getItem(LS_KEY) || "AUD");

  useEffect(() => {
    api.get("/currency/rates").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const setCurrency = useCallback((code) => {
    localStorage.setItem(LS_KEY, code);
    setCurrencyState(code);
  }, []);

  const rate = data?.rates?.[currency] ?? 1;
  const symbol = data?.currencies?.find((c) => c.code === currency)?.symbol ?? "A$";

  const convert = useCallback((aud) => Number(aud || 0) * rate, [rate]);
  const fmt = useCallback((aud, decimals = 2) => {
    const n = Number(aud || 0) * rate;
    return `${symbol}${n.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
  }, [rate, symbol]);

  return (
    <CurrencyContext.Provider value={{
      currency, setCurrency, convert, fmt, rate, symbol,
      currencies: data?.currencies || [],
      ratesLive: data?.live ?? true,
      ready: !!data,
    }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
